import { addHours, compareAsc, format, toDate } from "date-fns";
import { Storage as storage } from "@/App/services/LocalStorage";

export const getAutoLogoutTime = () => {
  const autoLogoutTimestamp = Number(storage.getItem("autoLogoutTime"));

  if (autoLogoutTimestamp) {
    const autoLogoutTime = format(toDate(autoLogoutTimestamp), "HH:mm:ss");

    return autoLogoutTime;
  }

  return null;
};

export const getSuggestedAutoLogoutTime = () => {
  const now = toDate(Date.now());

  const suggestedAutoLogoutTime = addHours(now, 8);

  const formattedSuggestedAutoLogoutTime = format(suggestedAutoLogoutTime, "HH:mm:ss");

  return formattedSuggestedAutoLogoutTime;
};

const checkAutoLogout = ({ dispatch }) => {
  const autoLogoutTime = Number(storage.getItem("autoLogoutTime"));

  if (autoLogoutTime) {
    const x = compareAsc(toDate(autoLogoutTime), toDate(Date.now()));

    if (x === -1) {
      dispatch("logout");
      dispatch("setAutoLogout", null);

      return true;
    }

    return false;
  }
};

export const runAutoLogoutCheckService = ({ dispatch }) => {
  const pastAutoLogoutTime = checkAutoLogout({ dispatch });

  if (pastAutoLogoutTime === true) {
    window.alert("Auto-Logout time has been reached. Please login again to continue working.");

    return;
  }

  setTimeout(() => {
    runAutoLogoutCheckService({ dispatch });
  }, 5000);
};
